/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const setMark = (mark: string): void => {
	if (typeof performance !== 'object' || typeof performance.mark !== 'function') {
		return;
	}

	performance.mark(mark);
};

const TRACE_ID_HEADER = 'atl-traceid';
const TRACE_ID_HEADER_MICROS = 'x-trace-id';
export const getTraceId = (response: Response): string | null =>
	response.headers.get(TRACE_ID_HEADER) || response.headers.get(TRACE_ID_HEADER_MICROS);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { FetchError } from './types';
